import moment from 'moment';

export default date => {
	if (date) {
		return moment(date).format('Do MMM YYYY, HH:mm');
	}
};
